import { addWindowScrollEvent } from 'theme-utilities';
import { DESKTOP_BREAKPOINT, ELEMENTS } from './lib';

const setLeftSubNavOffset = () => {
	const containerWidth = ELEMENTS.navContainer().getBoundingClientRect().width;

	ELEMENTS.firstLevelSubmenuListItems().forEach((listItem) => {
		const submenu = listItem.querySelector('nav.sub--menu');
		const submenuWidth = submenu.getBoundingClientRect().width;

		// If the subnav is smaller than the container, align it to the 1st level nav menu item
		if (submenuWidth < containerWidth) {
			const offset = listItem.offsetLeft + listItem.getBoundingClientRect().width / 2;

			const targetPositionLeft = offset - submenuWidth / 2;
			const targetPositionRight = offset + submenuWidth / 2;

			const containerLeftEdge = ELEMENTS.navContainer().offsetLeft;
			const containerRightEdge = ELEMENTS.navContainer().offsetLeft + containerWidth;

			if (targetPositionLeft >= containerLeftEdge && targetPositionRight <= containerRightEdge) {
				submenu.style.setProperty('--subnav-offset-left', `${offset}px`);
			} else if (targetPositionLeft < containerLeftEdge) {
				submenu.style.setProperty('--subnav-offset-left', `${containerLeftEdge + submenuWidth / 2}px`);
			} else if (targetPositionRight > containerRightEdge) {
				submenu.style.setProperty('--subnav-offset-left', `${containerRightEdge - submenuWidth / 2}px`);
			}
		}
	});
};

const setTopSubNavOffset = () => {
	if (ELEMENTS.nav()) {
		const headerNavRect = ELEMENTS.nav().getBoundingClientRect();
		const offsetTop = headerNavRect.top + headerNavRect.height;
		ELEMENTS.nav().style.setProperty('--subnav-offset-top', `${offsetTop}px`);
	}
};

const resizeObserver = new ResizeObserver((entries) => {
	for (const entry of entries) {
		if (entry.contentRect.width >= DESKTOP_BREAKPOINT) {
			setLeftSubNavOffset();
			setTopSubNavOffset();
		}
	}
});
resizeObserver.observe(document.body);

addWindowScrollEvent(setTopSubNavOffset);
